<clr-modal
  [clrModalSize]="size"
  [clrModalClosable]="clrModalClosable"
  [(clrModalOpen)]="isOpened"
  (clrModalOpenChange)="onIsOpenedChanged($event)"
  [@fadeIn]="isOpened"
>
  <div class="modal-title">{{ modalTitle }}</div>
  <div class="modal-body scrollable-content">
    <ng-content></ng-content>
  </div>
</clr-modal>
